module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    staticClass: "flex-grid--vertical",
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Loss of Pension",
      "icon": "loss-of-pension"
    }
  }), _vm._v(" "), _c('div', [_c('control', {
    attrs: {
      "for": "gender",
      "label": "Gender"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "gender",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.handler]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('gender')
    }
  }, [_vm._v("\n                        The Gender is required\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "date_of_birth",
      "label": "Date of Birth"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_of_birth.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_of_birth",
      modifiers: {
        "required": true
      }
    }],
    ref: "dateOfBirth",
    on: {
      "input": _vm.handler
    },
    model: {
      value: (_vm.dateOfBirth),
      callback: function($$v) {
        _vm.dateOfBirth = $$v
      },
      expression: "dateOfBirth"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_of_birth')
    }
  }, [_vm._v("\n                        The date of birth is required and must be in the format DD/MM/YYYY\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "date_of_assumed_settlement",
      "label": "Date of Assumed Settlement/Trial"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_of_assumed_settlement.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_of_assumed_settlement",
      modifiers: {
        "required": true
      }
    }],
    ref: "dateOfAssumedSettlement",
    on: {
      "input": _vm.handler
    },
    model: {
      value: (_vm.dateOfAssumedSettlement),
      callback: function($$v) {
        _vm.dateOfAssumedSettlement = $$v
      },
      expression: "dateOfAssumedSettlement"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('date_of_assumed_settlement')
    }
  }, [_vm._v("\n                        The date of assumed settlement/trial is required and must be in the format DD/MM/YYYY\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "pension_method",
      "label": "Simple Method or Longden Method?"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pensionMethod),
      expression: "pensionMethod"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "pension_method",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pensionMethod = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "simple"
    }
  }, [_vm._v("Simple")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "longden",
      "disabled": ""
    }
  }, [_vm._v("Longden (coming soon)")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('pension_method')
    }
  }, [_vm._v("\n                        The Simple Method or Longden Method is required\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "lump_sum_payment",
      "label": "Is there a lump sum payment?"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lumpSumLoss),
      expression: "lumpSumLoss"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "lump_sum_loss",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.lumpSumLoss = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.handler]
    }
  }, [_c('option', {
    attrs: {
      "hidden": "",
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('lump_sum_payment')
    }
  }, [_vm._v("\n                        The lump sum payment is required\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "but_for_retirement_date",
      "label": _vm.lumpSumLoss ? '\'But For\' Retirement Date/Date Lump Sum Would Have Been Taken' : '\'But For\' Retirement Date'
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:but_for_retirement_date.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "but_for_retirement_date",
      modifiers: {
        "required": true
      }
    }],
    on: {
      "update": _vm.handler
    },
    model: {
      value: (_vm.butForRetirementDate),
      callback: function($$v) {
        _vm.butForRetirementDate = $$v
      },
      expression: "butForRetirementDate"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('but_for_retirement_date')
    }
  }, [_vm._v("\n                        The 'But for' Retirement Date is required\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "but_for_retirement_age",
      "label": _vm.lumpSumLoss ? '\'But For\' Retirement Age/Age Lump Sum Would Have Been Taken' : '\'But For\' Retirement Age',
      "before-after": "years"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.butForRetirementAge),
      expression: "butForRetirementAge",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:but_for_retirement_age.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "but_for_retirement_age",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "but_for_retirement_age",
      "type": "number"
    },
    domProps: {
      "value": (_vm.butForRetirementAge)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.butForRetirementAge = _vm._n($event.target.value)
      }, _vm.handler],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('but_for_retirement_age')
    }
  }, [_vm._v("\n                        The 'But for' Retirement Age is required\n                    ")])], 1)], 1), _vm._v(" "), (_vm.lumpSumLoss) ? _c('div', [_c('h2', {
    staticClass: "u-r-margin-top-40"
  }, [_vm._v("\n                    Lump Sum Loss\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "but_for_pension_lump_sum",
      "label": "'But For' Pension Lump Sum",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.butForPensionLumpSum),
      expression: "butForPensionLumpSum",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:but_for_pension_lump_sum.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "but_for_pension_lump_sum",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "but_for_pension_lump_sum",
      "type": "number"
    },
    domProps: {
      "value": (_vm.butForPensionLumpSum)
    },
    on: {
      "focus": function($event) {
        _vm.butForPensionLumpSum = _vm.butForPensionLumpSum || ''
      },
      "blur": [function($event) {
        _vm.butForPensionLumpSum = _vm.butForPensionLumpSum || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.butForPensionLumpSum = _vm._n($event.target.value)
      }, _vm.handler]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.lumpSumValid
    }
  }, [_vm._v("\n                        'But For' Pension Lump Sum must be greater than the Lump Sum Payment After the Accident\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "pension_lump_sum",
      "label": "Actual Lump Sum Payment",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pensionLumpSum),
      expression: "pensionLumpSum",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:pension_lump_sum.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "pension_lump_sum",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "pension_lump_sum",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pensionLumpSum)
    },
    on: {
      "focus": function($event) {
        _vm.pensionLumpSum = _vm.pensionLumpSum || ''
      },
      "blur": [function($event) {
        _vm.pensionLumpSum = _vm.pensionLumpSum || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pensionLumpSum = _vm._n($event.target.value)
      }, _vm.handler]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.lumpSumValid
    }
  }, [_vm._v("\n                        Lump Sum Payment After the Accident must be less than the 'But For' Pension Lump Sum\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "date_lump_sum_received",
      "label": "Date Lump Sum Payment Received"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:date_lump_sum_received.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "date_lump_sum_received",
      modifiers: {
        "required": true
      }
    }],
    on: {
      "update": _vm.handler
    },
    model: {
      value: (_vm.dateLumpSumPaymentReceived),
      callback: function($$v) {
        _vm.dateLumpSumPaymentReceived = $$v
      },
      expression: "dateLumpSumPaymentReceived"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "u-r-margin-top-40"
  }, [_vm._v("\n                    Pension Losses\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "but_for_retirement_date",
      "label": "'But For' Pension Annual Income",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.butForPensionAnnual),
      expression: "butForPensionAnnual",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:but_for_pension_annual.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "but_for_pension_annual",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "but_for_pension_annual",
      "type": "number"
    },
    domProps: {
      "value": (_vm.butForPensionAnnual)
    },
    on: {
      "focus": function($event) {
        _vm.butForPensionAnnual = _vm.butForPensionAnnual || ''
      },
      "blur": [function($event) {
        _vm.butForPensionAnnual = _vm.butForPensionAnnual || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.butForPensionAnnual = _vm._n($event.target.value)
      }, _vm.handler]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.pensionAnnualIncomeValid
    }
  }, [_vm._v("\n                        'But For' Pension Annual Income must be greater than Actual Pension Annual Income\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "pension_annual",
      "before-after": "pound",
      "label": "Actual Pension Annual Income"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pensionAnnual),
      expression: "pensionAnnual",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:pension_annual.required",
      value: ({
        type: 'number',
        rules: 'min:0.00'
      }),
      expression: "{type:'number', rules:'min:0.00'}",
      arg: "pension_annual",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "0",
      "id": "pension_annual",
      "type": "number"
    },
    domProps: {
      "value": (_vm.pensionAnnual)
    },
    on: {
      "focus": function($event) {
        _vm.pensionAnnual = _vm.pensionAnnual || ''
      },
      "blur": [function($event) {
        _vm.pensionAnnual = _vm.pensionAnnual || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pensionAnnual = _vm._n($event.target.value)
      }, _vm.handler]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.pensionAnnualIncomeValid
    }
  }, [_vm._v("\n                        Actual Pension Annual Income must be less than 'But For' Pension Annual Income\n                    ")])], 1)], 1), _vm._v(" "), _c('h2', {
    staticClass: "u-r-margin-top-40"
  }, [_vm._v("\n                Result\n            ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "total_loss",
      "label": "Total Loss",
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.totalLoss),
      expression: "totalLoss"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "disabled",
      "id": "total_loss",
      "type": "number",
      "name": "total_loss"
    },
    domProps: {
      "value": (_vm.totalLoss)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.totalLoss = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalLoss),
      expression: "totalLoss"
    }],
    staticClass: "flex-grid--vertical",
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto"
  }, [_c('h2', [_vm._v("Explanation")]), _vm._v(" "), _c('h2', [_vm._v("Pension Loss")]), _vm._v(" "), _c('p', [_vm._v("\n                Based on the 'But For' retirement date ("), _c('strong', [_vm._v(_vm._s(_vm.butForRetirementDate))]), _vm._v(") and Date of Assumed Settlement/Trial\n                ("), _c('strong', [_vm._v(_vm._s(_vm.dateOfAssumedSettlement))]), _vm._v(").\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                The pension multiplier is "), _c('strong', [_vm._v(_vm._s(_vm.pensionLossMultiplier))])]), _c('div', {
    staticStyle: {
      "margin-top": "-40px",
      "margin-left": "225px"
    },
    on: {
      "click": _vm.togglePensionMultiplierModal
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "formula",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1), _vm._v(" "), _c('p'), _vm._v(" "), (_vm.lumpSumLoss) ? _c('div', [_c('h2', [_vm._v("Lump Sum Loss")]), _vm._v(" "), _c('p', [_vm._v("\n                    Based on the Date Lump Sum Payment Received ("), _c('strong', [_vm._v(_vm._s(_vm.dateLumpSumPaymentReceived))]), _vm._v(") the Period of Accelerated Receipt\n                    is "), _c('strong', [_vm._v(_vm._s(_vm.acceleratedReceipt))]), _vm._v(" years.\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    Table 35 Discount Factor: "), _c('strong', [_vm._v(_vm._s(_vm.discountFactor))])]), _c('div', {
    staticStyle: {
      "margin-top": "-40px",
      "margin-left": "240px"
    },
    on: {
      "click": _vm.toggleDiscountFactorModal
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "icon-type": "formula",
      "tooltip-text": "Click to view calculations",
      "side": "right",
      "text-width": "140"
    }
  })], 1), _vm._v(" "), _c('p'), _vm._v(" "), _c('p'), _c('h2', [_vm._v("Lump Sum Loss Formula")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p'), _c('div', {
    staticClass: "m-formula"
  }, [_c('div', {
    staticClass: "m-formula__item--row"
  }, [_c('strong', [_vm._v("\n                                Table 35 Discount Factor x ('But For' Pension Lump Sum - Actual Lump Sum Payment) = Lump Sum Loss\n                            ")])])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p'), _c('h2', [_vm._v("Lump Sum Loss")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p'), _c('div', {
    staticClass: "m-formula"
  }, [_c('div', {
    staticClass: "m-formula__item--row"
  }, [_c('strong', [_vm._v("\n                                " + _vm._s(_vm.discountFactor) + " x (" + _vm._s(_vm.currencyFormat(_vm.butForPensionLumpSum)) + " - " + _vm._s(_vm.currencyFormat(_vm.pensionLumpSum)) + ") = " + _vm._s(_vm.currencyFormat(_vm.lumpSumLossPresentValue)) + "\n                            ")])])]), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), _c('p'), _c('h2', [_vm._v("Pension Loss Formula")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p'), _c('div', {
    staticClass: "m-formula"
  }, [_c('div', {
    staticClass: "m-formula__item--row"
  }, [_c('strong', [_vm._v("\n                            Pension Multiplier x ('But For' Pension Annual Income - Actual Pension Annual Income)\n                            "), (_vm.lumpSumLoss) ? _c('span', [_vm._v(" + Lump Sum Loss")]) : _vm._e(), _vm._v(" = Total Annual Loss\n                        ")])])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p'), _c('h2', [_vm._v("Pension Loss")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p'), _c('div', {
    staticClass: "m-formula"
  }, [_c('div', {
    staticClass: "m-formula__item--row"
  }, [_c('strong', [_vm._v("\n                        " + _vm._s(_vm.pensionLossMultiplier) + " x (" + _vm._s(_vm.currencyFormat(_vm.butForPensionAnnual)) + " - " + _vm._s(_vm.currencyFormat(_vm.pensionAnnual)) + ")\n                        "), (_vm.lumpSumLoss) ? _c('span', [_vm._v(" + " + _vm._s(_vm.currencyFormat(_vm.lumpSumLossPresentValue)))]) : _vm._e(), _vm._v(" = " + _vm._s(_vm.currencyFormat(_vm.totalLoss)) + "\n                    ")])])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p')]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "pension_multiplier_modal",
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "discount_factor_modal",
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7feb1b94!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mini-calculators/calculators/lossOfPension.vue
// module id = 1760
// module chunks = 0